import { useLoad } from "@/lib/hooks";
import { api } from "@/lib/api";
import { act } from "@/lib/hooks";

export const EMP_TYPES = [{ value: "full_time", label: "Full-time" }, { value: "part_time", label: "Part-time" }, { value: "contract", label: "Contract" }];
export const EMP_STATUS = [{ value: "active", label: "Active" }, { value: "on_leave", label: "On leave" }, { value: "terminated", label: "Terminated" }];
export const LEAVE_TYPES = [{ value: "annual", label: "Annual" }, { value: "sick", label: "Sick" }, { value: "maternity_paternity", label: "Maternity / paternity" }, { value: "unpaid", label: "Unpaid" }];
export const label = (list, v) => list.find((x) => x.value === v)?.label || v;
export const STATUS_BADGE = { active: "active", on_leave: "on_leave", terminated: "canceled", pending: "pending", approved: "approved", rejected: "failed", none: "canceled" };

export function useBranches() {
  const [d] = useLoad("/tenant/branches");
  return (d?.branches || []).map((b) => ({ value: b.id, label: b.name }));
}

export function useEmployees() {
  const [rows, reload] = useLoad("/hr/employees");
  return [rows || [], reload];
}

export async function openPdf(url) {
  const r = await act(() => api.get(url, { responseType: "blob" }));
  if (r) window.open(URL.createObjectURL(r), "_blank");
}

export async function download(url, name) {
  const r = await act(() => api.get(url, { responseType: "blob" }));
  if (!r) return;
  const a = document.createElement("a");
  a.href = URL.createObjectURL(r);
  a.download = name;
  a.click();
}
